import { Container, Paper } from '@mantine/core';
import { UserSurvey, UserSurveyData } from './user-survey';
import type { UseFormReturnType } from '@mantine/form';
import type { ParsedData, Loan } from '@/types/nsldsTypes';

export interface SurveyStepProps {
  form: UseFormReturnType<UserSurveyData>;
  isMobile?: boolean;
  userFile: File | null;
  setUserFile: (file: File | null) => void;
  partnerFile: File | null;
  setPartnerFile: (file: File | null) => void;
  userManualLoan: Loan | null;
  setUserManualLoan: (loan: Loan | null) => void;
  partnerManualLoan: Loan | null;
  setPartnerManualLoan: (loan: Loan | null) => void;
  isLoadingUserFile: boolean;
  isLoadingPartnerFile: boolean;
  userFileError: string | null;
  setUserFileError: (error: string | null) => void;
  partnerFileError: string | null;
  setPartnerFileError: (error: string | null) => void;
  setUserParsedData: (data: ParsedData | null) => void;
  setPartnerParsedData: (data: ParsedData | null) => void;
  setIsLoadingUserFile: (isLoading: boolean) => void;
  setIsLoadingPartnerFile: (isLoading: boolean) => void;
  userParsedData: ParsedData | null;
  partnerParsedData: ParsedData | null;
}

export function SurveyStep({
  form,
  isMobile = false,
  userFile,
  setUserFile,
  partnerFile,
  setPartnerFile,
  userManualLoan,
  setUserManualLoan,
  partnerManualLoan,
  setPartnerManualLoan,
  isLoadingUserFile,
  isLoadingPartnerFile,
  userFileError,
  setUserFileError,
  partnerFileError,
  setPartnerFileError,
  setUserParsedData,
  setPartnerParsedData,
  userParsedData,
  partnerParsedData,
}: SurveyStepProps) {
  return (
    <Container fluid p={isMobile ? 'sm' : 'xl'} pt={isMobile ? 'sm' : 0}>
      <Paper shadow="none" p={0} style={{ backgroundColor: 'transparent' }}>
        <UserSurvey
          form={form}
          userFile={userFile}
          setUserFile={setUserFile}
          partnerFile={partnerFile}
          setPartnerFile={setPartnerFile}
          userManualLoan={userManualLoan}
          setUserManualLoan={setUserManualLoan}
          partnerManualLoan={partnerManualLoan}
          setPartnerManualLoan={setPartnerManualLoan}
          isLoadingUserFile={isLoadingUserFile}
          isLoadingPartnerFile={isLoadingPartnerFile}
          userFileError={userFileError}
          setUserFileError={setUserFileError}
          partnerFileError={partnerFileError}
          setPartnerFileError={setPartnerFileError}
          setUserParsedData={setUserParsedData}
          setPartnerParsedData={setPartnerParsedData}
          userParsedData={userParsedData}
          partnerParsedData={partnerParsedData}
        />
      </Paper>
    </Container>
  );
}
